import React from 'react';

interface KakaoIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const KakaoIcon: React.FC<KakaoIconProps> = ({ 
  width = 20, 
  height = 20, 
  className = "" 
}) => {
  return (
    <svg 
      viewBox="0 0 24 24" 
      width={width} 
      height={height}
      className={className}
    >
      <rect width="24" height="24" rx="4" fill="#FEE500"/>
      <path d="M12 6.5C8.13 6.5 5 8.69 5 11.5c0 1.8 1.17 3.38 2.94 4.24l-.75 2.88 3.31-1.66c.44.08.89.12 1.35.12 3.87 0 7-2.19 7-4.9 0-2.71-3.13-4.9-7-4.9z" fill="#000000"/>
    </svg>
  );
};

export default KakaoIcon;
